// extracted by mini-css-extract-plugin
export default {"sendIcon":"o8Q9tU","textField":"UqaWZb"};